import { ITransportAccessibilityInsideWithOrder } from '../../repositories/infrastructure-caching/entities/get_infrastructure/TransportAccessibilityInsideWithOrder';
import { ITransportAccessibilityOutsideWithOrder } from '../../repositories/infrastructure-caching/entities/get_infrastructure/TransportAccessibilityOutsideWithOrder';
import { ITransportAccessibilityWithOrder } from '../../repositories/infrastructure-caching/entities/get_infrastructure/TransportAccessibilityWithOrder';
import { IDistrictTransportAccessibility, ITaPoi, TTaGroups } from '../../types/infrastructure';

interface IRawTaItem {
  id: string;
  coordinates: { lat: number; lng: number };
  title?: string | null;
  line?: { color: string } | null;
  description?: string | null;
}

function mapItems(items: IRawTaItem[] | null | undefined): ITaPoi[] | undefined {
  if (!items?.length) {
    return undefined;
  }

  return items.map(item => ({
    id: item.id,
    coordinates: { lat: item.coordinates.lat, lng: item.coordinates.lng },
    // У двора без машин вместо названия приходит description.
    title: item.title ?? item.description ?? undefined,
    lineColor: item.line?.color ?? null,
  }));
}

function mapOutsideGroups(outside: ITransportAccessibilityOutsideWithOrder): TTaGroups {
  return {
    busStops: mapItems(outside.busStops),
    tramStops: mapItems(outside.tramStops),
    metro: mapItems(outside.metro),
    parking: mapItems(outside.parking),
    bikeParking: mapItems(outside.bikeParking),
    scooterParking: mapItems(outside.scooterParking),
    chargingStations: mapItems(outside.chargingStations),
  };
}

function mapInsideGroups(inside: ITransportAccessibilityInsideWithOrder): TTaGroups {
  return {
    parking: mapItems(inside.parking),
    bikeParking: mapItems(inside.bikeParking),
    scooterParking: mapItems(inside.scooterParking),
    chargingStations: mapItems(inside.chargingStations),
    yardWithoutCars: mapItems(inside.yardWithoutCars),
    boulevards: mapItems(inside.boulevards),
    trafficSafetyElements: mapItems(inside.trafficSafetyElements),
    dropOffPickUpArea: mapItems(inside.dropOffPickUpArea),
  };
}

function hasAnyGroup(groups: TTaGroups | undefined): boolean {
  return Boolean(groups && Object.values(groups).some(items => items?.length));
}

/**
 * Переводит блок «Транспортная доступность» из ответа infrastructure-caching в точки для карты.
 * Возвращает null, когда все категории обоих табов пустые — по этому признаку скрывается переключатель режима.
 */
export function mapTransportAccessibility(
  transportAccessibility: ITransportAccessibilityWithOrder | null | undefined,
): IDistrictTransportAccessibility | null {
  if (!transportAccessibility) {
    return null;
  }

  const outside = mapOutsideGroups(transportAccessibility.outside);
  const inside = transportAccessibility.inside ? mapInsideGroups(transportAccessibility.inside) : undefined;

  if (!hasAnyGroup(outside) && !hasAnyGroup(inside)) {
    return null;
  }

  return { outside, inside };
}
